import store from "@frameworks/web/redux/store";
import { INVESTOR_DATA, INVESTOR_HIDE_ERROR, INVESTOR_SET_ERROR, INVESTOR_START_LOADER, INVESTOR_STOP_LOADER, } from "../../interfaces/Home/iInvestor";
class InvestorActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getInvestor(data) {
        this.dispatch({
            type: INVESTOR_DATA,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: INVESTOR_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: INVESTOR_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: INVESTOR_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: INVESTOR_HIDE_ERROR,
        });
    }
}
export default InvestorActions;
